import { ThisConnector } from '../../../../api/connector'
import {
  Exclusion,
  ExclusionApiResponse,
  ExclusionRequestArgs,
  normalizeExclusionResponse
} from './shared'

export async function getAppExclusion(
  this: ThisConnector,
  { organizationUuid, applicationId, exclusionId }: ExclusionRequestArgs
): Promise<Exclusion> {
  const { exception } = await this.connector.get<ExclusionApiResponse>(
    `/${organizationUuid}/applications/${applicationId}/exclusions/${exclusionId}`
  )
  return normalizeExclusionResponse(exception)
}
